import { skipToken } from '@reduxjs/toolkit/query';

import { getUserProfile } from 'api/authAPI';
import { handleError } from 'services/Error';
import { type AppThunk, useAppSelector } from 'store';
import { useGetSupplierDetailsQuery } from 'store/api/referenceApi';
import { setProfile } from 'store/auth/authSlice';

export const fetchAuthProfile = (): AppThunk<Promise<void>> => async (dispatch) => {
    try {
        const result = await getUserProfile();
        const [firstName, ...restOfName] = result.full_name.split(' ');
        dispatch(
            setProfile({
                profile: {
                    fullName: result.full_name,
                    firstName,
                    lastName: restOfName.join(' '),
                    email: result.upn,
                    organizations: result.pharmacies.map((pharmacy) => ({
                        organizationName: pharmacy.organization_name,
                        supplierNpi: pharmacy.supplier_npi,
                        role: pharmacy.display_name,
                    })),
                },
            }),
        );
    } catch (error) {
        handleError('An error occurred retrieving profile settings.', error as Error);
    }
};

export const useLoggedInSupplierName = () => {
    const { selectedNpi } = useAppSelector((state) => state.auth);
    const { data: supplierDetails } = useGetSupplierDetailsQuery(
        selectedNpi ? { npi: selectedNpi } : skipToken,
    );
    return supplierDetails?.name;
};
